export class UserSocial {
  profileId: string;
  influencerId: number;
  id: number;
  socialNetwork: SocialNetworkType;
  url?: string;
  username?: string;
}

export enum SocialNetworkType {
  TWITTER = 'TWITTER',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  YOUTUBE = 'YOUTUBE',
  GITHUB = 'GITHUB',
  MEDIUM = 'MEDIUM',
  TELEGRAM = 'TELEGRAM',
  DISCORD = 'DISCORD',
  WEBSITE = 'WEBSITE',
  OTHER = 'OTHER',
}
